// block-quotes.directive.ts
import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appBlockQuotes]'
})
export class BlockQuotesDirective {

  private regex: RegExp = new RegExp(/['"]/);

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.key === '"' || event.key === "'") {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedInput = clipboardData.getData('text');

    if (this.regex.test(pastedInput)) {
      event.preventDefault();
    }
  }
}
